import './Editprofile.css';
export default function Editprofile() {
  return (
    <>
    <div className='profile-container'>
        <div className='profile-card'>
            <h2>admin settings</h2>
            <p>manage your profile, security settings</p>
        </div>
        <div>
            <button>profile</button>
            <button>settings</button>
            <div>
                <div className='profile-info-card'>
                  <div className='profile-header'>
                    <h5>profile information</h5>
                    <button>back</button>
                    <button>save details</button>
                  </div>
                  <div className='profile-box'>
                    <div className='profile-pic'>
                      <div className='photo'></div>
                      <div className='details'>
                        <p>user name</p>
                        <p>super admin</p>
                      </div>
                    </div>
                    <div className='profile-details'>
                        <p>profile information</p>
                        <form action="">
                            <label htmlFor="name">first name</label>
                            <input type="text" id="name" placeholder='enter your first name' />

                            <label htmlFor="name">last name</label>
                            <input type="text" id="name" placeholder='enter your last name' />

                            <label htmlFor="email">email address</label>
                            <input type="email" id="email" placeholder='admin@example.com' />
                        </form>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}